<template>
  <div :menuList="menuList" ref="menuList" class="menu-button-list">
    <MenuButton
      v-for="(item, i) in this.menuList"
      :class="{
        'button-active': selectedIndex === i,
        'button-inactive': selectedIndex !== i,
      }"
      :bt-name="item.name"
      @click.native="handleSelect(i, item.path)"
      :key="i"
    ></MenuButton>
  </div>
</template>

<script>
import MenuButton from "../MenuButton"
export default {
  props: {
    menuList: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    MenuButton,
  },
  data() {
    return {
      selectedIndex: 0,
    }
  },
  computed: {
    navLevel: function () {
      return this.$store.state.menuLevel
    },
    isLogin: function () {
      return this.$store.state.isLogin
    },
  },
  watch: {
    navLevel: {
      handler() {
        this.selectedIndex = 0
      },
    },
    isLogin: {
      handler() {
        this.selectedIndex = 0
      },
    },
  },
  mounted() {},
  methods: {
    handleSelect(i, path) {
      this.selectedIndex = i
      this.$router.push(path)
    },
  },
}
</script>

<style lang="scss">
.menu-button-list {
  display: flex;
  align-items: center;
}
</style>
